export enum StructuredDataType {
  NewsArticle = 'NewsArticle',
}

export enum StructuredDataAuthorType {
  Person = 'Person',
  Organization = 'Organization',
}

export interface StructuredDataAuthorProps {
  '@type': StructuredDataAuthorType;
  name: string;
  url: string;
}
